import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	display: flex;
	height: 65vh;
`;

export const Sidebar = styled.div`
	display: flex;
	flex-direction: column;
	min-height: 100%;
	width: 320px;
	min-width: 320px;
	background: ${colors.white};
	box-shadow: 1px 2px 4px ${colors.grey3};
	padding-top: 20px;
	overflow: auto;
	z-index: 0;
`;

export const Section = styled.div`
	padding: 12px 32px;
	width: 100%;
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	justify-content: space-between;
	height: 100%;
`;

export const Title = styled.p`
	font-weight: 500;
	font-size: 19px;
	line-height: 27px;
	margin-bottom: 16px;
`;

export const Description = styled.div`
	font-size: 13px;
	letter-spacing: 0.3px;
	line-height: 19px;
	color: ${colors.grey5};
	letter-spacing: 0.3px;
	margin-bottom: 15px;
`;

export const BottomSection = styled.div``;

export const Content = styled.div`
	width: 100%;
	display: flex;
	overflow: auto;
	padding: 48px 32px;
	background-color: ${colors.grey1};
	flex-wrap: nowrap;
	flex-direction: column;
`;

export const DropWrapper = styled.div`
	outline: none;
	width: 100%;
	display: flex;
	flex-direction: column;
`;

export const DropZoneArea = styled.div`
	display: flex;
	background-color: white;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	padding: 32px;
	border-width: 1px 1px 1px 1px;
	border-color: ${colors.grey4};
	border-style: dashed;
	border-radius: 0 0 3px 3px;
`;

export const IconWrapper = styled.div`
	margin-bottom: 32px;
`;

export const DropZoneText = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	align-items: center;
`;

export const DescriptionText = styled.div`
	width: 150px;
	color: ${colors.grey5};
	font-size: 13px;
	line-height: 19px;
	text-align: center;
	letter-spacing: 0.3px;

	span {
		font-weight: 700;
		font-size: 16px;
		color: ${colors.grey7};
	}
`;

export const ButtonWrapper = styled.div`
	padding-top: 20px;
`;

export const UploadInProgressWrapper = styled.div`
	padding: 3% 0;
	text-align: center;
	background-color: ${colors.white};
	border-width: 1px 1px 1px 1px;
	border-color: ${colors.grey4};
	border-style: dashed;
	border-radius: 0 0 3px 3px;
`;

export const DeleteDataWrapper = styled.div`
	padding: 0;
`;

export const LoaderWrapper = styled.div`
	width: 100%;
	text-align: center;
	padding: 100px 0;
`;

export const ExampleDownload = styled.div`
	display: flex;
	flex-direction: column;
	align-self: center;
	padding: 25px 0 0 0;
	width: 500px;
	text-align: center;
	align-items: center;

	> a {
		width: fit-content;
	}

	> span {
		font-size: 13px;
		line-height: 19px;
		color: ${colors.grey5};
		letter-spacing: 0.3px;
		padding-bottom: 16px;
	}
`;

export const DownloadLink = styled.a`
	font-size: 13px;
	font-weight: 500;
	text-transform: uppercase;
	color: ${colors.grey8};
	padding: 0 8px;
	height: 36px;
	line-height: 36px;
	display: inline-block;

	&:hover {
		background: #ecf3ea;
	}
`;
